import { mapState } from 'vuex'
import types from '@/utils/types'
import { EventBus } from '@/plugins/event-bus'

export const curatorNotesMixin = {
  data() {
    return {
      formNoteValid: false,
      curatorNotesDialog: false,
      loadingNotes: false,
      postingNote: false,
      note: '',
      noteRules: [v => !!v || 'Please enter your note']
    }
  },
  computed: {
    ...mapState({
      notes: state => state.photos.notes
    })
  },
  watch: {
    curatorNotesDialog: 'getNotes'
  },
  mounted() {
    EventBus.$on('open:notes:dialog', () => {
      this.curatorNotesDialog = true
    })
  },
  methods: {
    async getNotes(value) {
      if (value) {
        if (
          this.me &&
          (this.me.isAdmin || this.me.role === types.user.role.curator)
        ) {
          try {
            this.loadingNotes = true
            await this.$store.dispatch('photos/getNotes', this.photo.id)
          } catch (error) {
            this.$asa.appInsights('Mixins: curatorNotesMixin.js - method: getNotes', error)
          } finally {
            this.loadingNotes = false
          }
        }
      }
    },
    async postNote() {
      if (this.$refs.form.validate()) {
        try {
          this.postingNote = true
          const payload = {
            body: this.note,
            photoId: this.photo.id
          }
          await this.$store.dispatch('photos/postNote', payload)
          this.$refs.form.reset()
        } catch (error) {
          this.$asa.appInsights('Mixins: curatorNotesMixin.js - method: postNote', error)
        } finally {
          this.postingNote = false
        }
      }
    },
    noop() {}
  }
}
